import { Link } from "react-router-dom";

const footerLinks = {
  SHOP:    ["All Candles", "Fragrance Oils", "Wholesale"],
  SUPPORT: ["Track Order", "Returns & Refunds", "Candle Care", "Shipping Info"],
};

export default function Footer() {
  return (
    <footer
      id="contact"
      className="w-full"
      style={{ background: "#fff", borderTop: "1px solid #f0ebe3", padding: "60px 6% 28px" }}
    >
      <div
        className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12"
        style={{ maxWidth: "1200px", margin: "0 auto", paddingBottom: "40px", borderBottom: "1px solid #f0ebe3" }}
      >
        {/* Brand + Contact */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span style={{ color: "#e07b39", fontSize: "16px" }}>🕯️</span>
            <span className="font-bold uppercase tracking-widest"
              style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#1a1a1a", letterSpacing: "0.18em" }}>
              SJ Aroma
            </span>
          </div>
          <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#888", lineHeight: "1.8", maxWidth: "200px", marginBottom: "20px" }}>
            Hand poured in small batches in our Mumbai studio using 100% soy wax and premium fragrance oils.
          </p>

          {/* Contact details */}
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <a href="tel:+917021916502"
              style={{ display: "flex", alignItems: "center", gap: "8px", textDecoration: "none", fontFamily: "Georgia, serif", fontSize: "12px", color: "#555" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#e07b39")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}>
              <span style={{ fontSize: "14px" }}>📞</span>
              +91 70219 16502
            </a>
            <a href="mailto:sjaromacandles@gmail.com"
              style={{ display: "flex", alignItems: "center", gap: "8px", textDecoration: "none", fontFamily: "Georgia, serif", fontSize: "12px", color: "#555" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#e07b39")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}>
              <span style={{ fontSize: "14px" }}>✉️</span>
              sjaromacandles@gmail.com
            </a>
            <a href="https://instagram.com/candles_aroma143" target="_blank" rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "8px", textDecoration: "none", fontFamily: "Georgia, serif", fontSize: "12px", color: "#555" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#e07b39")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}>
              <span style={{ fontSize: "14px" }}>📸</span>
              @candles_aroma143
            </a>
          </div>

          {/* Social icon buttons — same links as contact details above */}
          <div className="flex gap-3 mt-5">
            {/* Instagram — same as @candles_aroma143 above */}
            <a href="https://instagram.com/candles_aroma143" target="_blank" rel="noopener noreferrer"
              style={{ width: "32px", height: "32px", background: "#f5f0e8", borderRadius: "50%",
                cursor: "pointer", color: "#888", fontFamily: "Georgia, serif", textDecoration: "none",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#e07b39"; e.currentTarget.style.color = "#fff"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "#f5f0e8"; e.currentTarget.style.color = "#888"; }}>
              ig
            </a>
            {/* Email — same as sjaromacandles@gmail.com above */}
            <a href="mailto:sjaromacandles@gmail.com"
              style={{ width: "32px", height: "32px", background: "#f5f0e8", borderRadius: "50%",
                cursor: "pointer", color: "#888", fontFamily: "Georgia, serif", textDecoration: "none",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#e07b39"; e.currentTarget.style.color = "#fff"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "#f5f0e8"; e.currentTarget.style.color = "#888"; }}>
              @
            </a>
            {/* Phone — same as +91 70219 16502 above */}
            <a href="tel:+917021916502"
              style={{ width: "32px", height: "32px", background: "#f5f0e8", borderRadius: "50%",
                cursor: "pointer", color: "#888", fontFamily: "Georgia, serif", textDecoration: "none",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#e07b39"; e.currentTarget.style.color = "#fff"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "#f5f0e8"; e.currentTarget.style.color = "#888"; }}>
              ☎
            </a>
          </div>
        </div>

        {/* Links */}
        {Object.entries(footerLinks).map(([section, links]) => (
          <div key={section}>
            <div className="font-bold text-xs tracking-widest uppercase mb-4"
              style={{ fontFamily: "Georgia, serif", color: "#1a1a1a", letterSpacing: "0.14em" }}>
              {section}
            </div>
            <ul className="flex flex-col gap-2.5" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {links.map((link) => (
                <li key={link}>
                  <Link to="#" className="text-xs transition-colors duration-150 no-underline"
                    style={{ fontFamily: "Georgia, serif", color: "#888" }}
                    onMouseEnter={(e) => (e.target.style.color = "#e07b39")}
                    onMouseLeave={(e) => (e.target.style.color = "#888")}>
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Location */}
        <div>
          <div className="font-bold text-xs tracking-widest uppercase mb-4"
            style={{ fontFamily: "Georgia, serif", color: "#1a1a1a", letterSpacing: "0.14em" }}>
            Our Location
          </div>
          <div className="rounded-xl flex items-center justify-center"
            style={{ height: "100px", background: "#f5f0e8", border: "1px solid #e8dfd0", marginBottom: "16px" }}>
            <div className="text-center">
              <div style={{ fontSize: "28px" }}>📍</div>
              <div style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa", marginTop: "6px" }}>
                Mira Road, Maharashtra, India
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-4"
        style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <p style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#bbb" }}>
          © 2025 SJ Aroma Candles. All rights reserved.
        </p>
        <div className="flex gap-6"></div>
      </div>
    </footer>
  );
}